import "unpoly/unpoly.css";
import "unpoly/unpoly.js";

export default (<any>window).up;
